import React from 'react';
import Chip from 'material-ui/Chip';
import {
	Responsive,
	Datagrid,
	SimpleList,
	List,
	TextField,
	FunctionField,
} from 'admin-on-rest';
import {
	ReferenceField,
} from 'admin-on-rest/lib/mui';
import AccountListActions from '../AccountListActions'
import AccountFilters from '../DCAccount/AccountFilters'
import customerName from '../CollectorAccount/customerName'
import { formatDate, stringHumanize } from '../util'
import AccountLinkField from '../DCAccount/AccountLinkField'

const DocStatus = ({ basePath = '', record = {} }) => {
	const { fields } = record
	if ( fields.has_pending_docs ) {

		const docs = fields.pending_docs
			.filter( ({ status }) => status !== 'complied' )
			.map( ({ name, document_other_name }) => (
				name !== 'other' ? stringHumanize( name ) : document_other_name
			) )

		return (
			<div style={{ paddingTop: "calc(48px / 2 - .5em)", paddingBottom: "calc(48px / 2 - .5em)" }}>
				{ docs.map( (name, i) => <div style={{ lineHeight: '1.7em' }} key={i}>{name}</div> )}
			</div>
		)
	}
	return null
}

export const SalesSupportHeadAccountList = (props) => {

	return (
    <List {...props}
		title="Support Head Account List"
		filters={<AccountFilters />}
		actions={<AccountListActions refreshInterval="900000" />}
		perPage={25}
		>
		<Responsive
            // small={
            //     <SimpleList
            //         primaryText={record => record.fields.cs_num}
            //         secondaryText={record => `${record.fields.branch} views`}
            //         tertiaryText={record => record.fields.dealer}
            //     />
            // }
            large={
				<Datagrid>
		            <AccountLinkField source="fields.cs_num" label="CS #" sortable={false} />
					<FunctionField label="Customer" render={customerName} />
					<ReferenceField label="Dealership" source="fields.dealership" sortable={false} reference="dealerships" allowEmpty validation={{ required: true }} linkType={false}>
						<TextField source="name"/>
					</ReferenceField>
					<ReferenceField label="Bank" source="fields.bank" reference="banks" allowEmpty sortable={false} validation={{ required: true }} linkType={false}>
						<TextField source="name"/>
					</ReferenceField>
					<FunctionField label="Status" render={ ({fields}) => <Chip>{stringHumanize(fields.status)}</Chip> } />
					<ReferenceField label="Account type" source="fields.payment_mode" reference="bank_payment_modes" linkType={false} sortable={false}>
						<TextField source="name"/>
					</ReferenceField>
					<FunctionField label="Released" render={ record => record.fields.released_date ? formatDate( record.fields.released_date ) : '' } />
					<TextField source="fields.days_untransmitted" label="# Days Untransmitted" sortable={false} />
					<DocStatus label="Pending Docs" />
					<TextField source="fields.sales_consultant" label="Sales Consultant" sortable={false} />
		        </Datagrid>
            }
        />
    </List>
	)
}



// WEBPACK FOOTER //
// ./src/SalesSupportHead/index.js